import React, {useEffect, useState} from "react";
import i18n from '../../../i18n'

export default function BottomInfo(props) {
    const {business, loading} = (props) = props;

    const [years, setYears] = useState(0)
    const [months, setMonths] = useState(0)
    const roi = business.roi
    const hasValidRoi = Number.isFinite(roi) && roi >= 0;

    const calculateRoi = () =>{
        if (!Number.isFinite(roi) || roi <= 0) {
            setYears(0);
            setMonths(0);
            return;
        }

        let calculatedYears = Math.floor(roi);
        let calculatedMonths = Math.round((roi - calculatedYears) * 12);

        if (calculatedMonths === 12) {
            calculatedYears += 1;
            calculatedMonths = 0;
        }

        setYears(calculatedYears);
        setMonths(calculatedMonths);
     }

    useEffect(() => {
        calculateRoi()
    },[loading, roi])

    return(
        <div className={"bulletpoints"}>
            <ul>
                <div className={"row"}>
                    <div className={"col-12 col-md-6"}>
                        <li><span className={"custom-bullet"}></span>
                            {i18n.t("business-detail.detail.followers")}
                        </li>
                        <p>{business.total_social_network_followers_stat.toLocaleString('de-DE')}</p>
                    </div>

                    <div className={"col-12 col-md-6"}>
                        <li><span className={"custom-bullet"}></span>
                        {i18n.t("business-detail.detail.subscribers")}
                        </li>
                        <p>{business.total_email_subscribers_stat.toLocaleString('de-DE')}</p>
                    </div>

                    <div className={"col-12 col-md-6"}>
                        <li><span className={"custom-bullet"}></span>
                            {i18n.t("business-detail.detail.organic")}
                        </li>
                        <p>{business.total_monthly_organic_visits_stat.toLocaleString('de-DE')}%</p>
                    </div>

                    <div className={"col-12 col-md-6"}>
                        
                    </div>

                   <div className={"col-12 col-md-6"}>
                        <li><span className={"custom-bullet"}></span>
                             {i18n.t("business-detail.detail.revenue")}
                        </li>
                        <p>{business?.user.country.currency_iso_code ? business.user.country.currency_iso_code : ''} { business.average_gross_revenue_stat.toLocaleString('de-DE') }</p>
                    </div>

                    <div className={"col-12 col-md-6"}>
                        <li><span className={"custom-bullet"}></span>
                        {i18n.t("business-detail.detail.roi")}
                        </li>
                        {months>0 && years>0?
                            <p>
                                { years } {i18n.t("business-detail.detail.years")} {months} {months === 1 ? "mes" : i18n.t("business-detail.detail.months")}
                            </p>
                            :
                            null
                        }

                        {months>=1 && years<=0?
                            <p>{months} {i18n.t("business-detail.detail.months")} </p>
                            :
                            null
                        }

                        {months<=0 && years>0?
                            <p>{years} {i18n.t("business-detail.detail.years")}</p>
                            :
                            null
                        }

                        {hasValidRoi && years === 0 && months === 0 ?
                            <p>0 {i18n.t("business-detail.detail.months")}</p>
                            :
                            null
                        }
                    </div>

                </div>
            </ul>

        </div>
    )
}
